module.exports = __webpack_public_path__ + "static/media/valor2_3_1.9492473b.png";